<div class="notification-container" *ngIf="isVisible">
  <!-- Notification Popup -->
  <div class="notification-popup notification-popup-flex" 
       [class.visible]="isVisible" 
       [class.expanded]="isExpanded">
    
    <!-- Header -->
    <div class="popup-header">
      <h3 class="popup-title">{{ 'notifications' | translate }}</h3>
      <div class="header-actions">
        <button class="action-btn" 
                (click)="markAllAsRead()" 
                [disabled]="unreadCount === 0">
          {{ 'mark_all_as_read' | translate }}
        </button>
        <div class="unread-badge" *ngIf="unreadCount > 0">
          {{ unreadCount }}
        </div>
        <button class="action-btn clear-btn" 
                (click)="clearAll()" 
                [disabled]="notifications.length === 0">
          {{ 'clear_all' | translate }}
        </button>
       <img class="close-icon" tooltip="{{'Close' | translate }}" alt="" placement="bottom" 
        tabindex="0" role="button"
        (click)="closePopup()" (keydown.enter)="closePopup()"
        src="assets/icon/cancel.svg">
      </div>
    </div>
      

    <!-- Notification List -->

    <div class="notification-list notification-list-flex" [ngStyle]="{
      'max-height': isExpanded ? '550px' : '180px',
      'overflow-y': 'auto'
    }">
      <div *ngIf="notifications.length === 0" class="empty-state">
        {{ 'no_notifications' | translate }}
      </div>
      <div *ngFor="let notification of notifications; trackBy: trackByNotificationId"
           class="notification-item"
            tabindex="0"
            role="button"
            (keydown.enter)="onNotificationClick(notification)"
            (keydown.space)="$event.preventDefault(); onNotificationClick(notification)"
           [class.unread]="!notification.isRead"
           [class.sliding-out]="slidingOutIds.has(notification.id)"
           (click)="onNotificationClick(notification)">
        <div class="notification-content">
          <div class="notification-title">{{ notification.title }}</div>
          <div class="notification-text" tooltip="{{ notification.text }}" placement="left">{{ notification.text }}</div>
        </div>
        <button class="close-btn" 
                (click)="dismissNotification($event, notification.id)">
          ×
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="popup-footer">
      <button class="view-all-btn" (click)="toggleExpanded()" [disabled]="notifications.length === 0">
        {{ isExpanded ? ('collapse' | translate) : ('view_all' | translate) }}
      </button>
    </div>
  </div>
</div>

<!-- Overlay - only show when popup is visible -->
<div class="overlay" 
     *ngIf="isVisible"
     [class.visible]="isVisible" 
     (click)="closePopup()">
</div>
